import React from 'react';
import {connect, useSelector} from 'react-redux';
import List from 'antd/lib/list';
import Comment from 'antd/es/comment';
import Avatar from 'antd/es/avatar';
import {
  deleteComment,
  getCommentRepliesData,
  getCommentsData,
  getMoreCommentRepliesData,
  readyToReplyComment,
  readyToUpdateComment,
} from '../../redux/actions/Comments';
import {
  getCommentDataReselector,
  getUserData, getUserIdReselector,
} from '../../redux/selectors/selectors';
import {getAvatarUrl, getDurationFromNow} from '../../helpers/util';

const CommentsListPre = props => {
  const userId = useSelector(getUserIdReselector);
  const comments = useSelector(getCommentDataReselector);

  const {count, commentsData: {edges: commentsList}, activeCommentId, activeCommentRepliesData: {edges: replyList, pageInfo: {hasNextPage}}} = comments;

  if (commentsList === null || commentsList.length < 1) return null;

  const {readyToUpdateComment, readyToReplyComment, getCommentRepliesData, getMoreCommentRepliesData, deleteComment} = props;

  const getActions = (commentId, innerCommentId, commentUserId, userName, message) => ([
    <span key={'comment-reply-' + commentId} onClick={() => readyToReplyComment(commentId, innerCommentId, userName)}>Reply</span>,
    userId === commentUserId ? <span key={'comment-edit-' + commentId} onClick={() => readyToUpdateComment(commentId, innerCommentId, message)}>Edit</span> : null,
    userId === commentUserId ? <span key={'comment-delete-' + commentId} onClick={() => deleteComment(commentId, innerCommentId)}>Delete</span> :null,
  ]);

  const buildViewMoreReplies = (index, backtalkId) => {
    if (replyList.length === index + 1 && hasNextPage) {
      return (
          <span
              className="view-replies"
              onClick={() => getMoreCommentRepliesData(backtalkId)}
          >- view more replies</span>
      );
    }
  };

  const renderComment = item => {
    const {backtalkId, message, updatedAt, replyCount, userInfo: {id: commentUserId, name: commentUserName, avatarUrl: commentUserAvatarUrl}} = item.node;
    return (
        <li>
          {
            replyList && replyList.length > 0 ? (
                <Comment
                    actions={getActions(backtalkId, '', commentUserId,
                        commentUserName, message)}
                    author={commentUserName}
                    avatar={<Avatar src={getAvatarUrl(commentUserAvatarUrl)}
                                    alt={commentUserName}/>}
                    content={<p>{message}</p>}
                    datetime={<span>{getDurationFromNow(updatedAt)}</span>}
                >
                  {
                    activeCommentId === backtalkId && (
                        replyList.map((reply, index) => {
                          const {backtalkId: replyId, message: replyMessage, updatedAt: replyUpdatedAt, userInfo: {id: replyUserId, name: replyUserName, avatarUrl: replyUserAvatarUrl}} = reply.node;
                          return (
                              <span key={replyId}>
                                <Comment
                                    actions={getActions(backtalkId, replyId,
                                        replyUserId, replyUserName,
                                        replyMessage)}
                                    author={replyUserName}
                                    avatar={<Avatar
                                        src={getAvatarUrl(replyUserAvatarUrl)}
                                        alt={replyUserName}/>}
                                    content={<p>{replyMessage}</p>}
                                    datetime={<span>{getDurationFromNow(
                                        replyUpdatedAt)}</span>}
                                />
                                {buildViewMoreReplies(index, backtalkId)}
                            </span>
                          );
                        })
                    )
                  }
                </Comment>
            ) : <Comment
                actions={getActions(backtalkId, '', commentUserId,
                    commentUserName, message)}
                author={commentUserName}
                avatar={<Avatar src={getAvatarUrl(commentUserAvatarUrl)}
                                alt={commentUserName}/>}
                content={<p>{message}</p>}
                datetime={<span>{getDurationFromNow(updatedAt)}</span>}
            />
          }
          {
            (replyCount > 0 && activeCommentId !== backtalkId) && (
                <span className="view-replies"
                      onClick={() => getCommentRepliesData(backtalkId)}>- view replies</span>
            )
          }
        </li>
    );
  };

  return (
      <List
          dataSource={commentsList}
          header={`${count} ${count > 1 ? 'comments' : 'comment'}`}
          itemLayout="horizontal"
          renderItem={renderComment}
      />
  );
};

const CommentsList = connect(null, {
  getCommentsData,
  readyToUpdateComment,
  readyToReplyComment,
  deleteComment,
  getCommentRepliesData,
  getMoreCommentRepliesData,
})(CommentsListPre);

export {CommentsList};
